import React, { FC, useState } from 'react';

import {
  Stack,
  HStack,
  Text,
  Box,
  OrderedList,
  ListItem,
  Link,
} from '@chakra-ui/react';
import { customTheme } from 'theme';

import { HelpCount } from 'components/DataDisplay/Utils/HelpCount';
import { CopyIcon } from 'components/Icons';
import { renderCopyIcon } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/OnboardGcp/utils';
import { CommandBox } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/utils/CommandBox';

interface Props {
  command: string;
}

export const CheckPermissionsRequired: FC<Props> = props => {
  const { command } = props;
  const [copied, setCopied] = useState('');

  return (
    <Stack px={2} spacing={8} h="full">
      <Stack spacing={4}>
        <HStack align={'start'}>
          <HelpCount count={1} />
          <Text fontWeight={600}>Execute the following steps:</Text>
        </HStack>
        <OrderedList pl={8} color={customTheme.colors.gray['300']} spacing={2}>
          <ListItem pl={4}>
            <HStack spacing={0}>
              <Box>Log in to Google Console (</Box>
              <Link
                color="primary"
                href="https://console.cloud.google.com"
                target="_blank"
              >
                https://console.cloud.google.com
              </Link>
              <Box>)</Box>)
            </HStack>
          </ListItem>
          <ListItem pl={4}>
            <Text>
              Go to{' '}
              <Text display="inline" color="primary">
                IAM
              </Text>
            </Text>
          </ListItem>
          <ListItem pl={4}>
            <Text>
              Under{' '}
              <Text display="inline" color="primary">
                Allow
              </Text>{' '}
              tab,
            </Text>
            <OrderedList spacing={2} pt={2} pl={6}>
              <ListItem pl={4}>
                <Text>
                  Click on the checkbox{' '}
                  <Text display="inline" color="primary">
                    Include Google-provided role grants
                  </Text>
                </Text>
              </ListItem>
              <ListItem pl={4}>
                <Text>
                  Select{' '}
                  <Text display="inline" color="primary">
                    Google APIs Service Agent
                  </Text>
                </Text>
              </ListItem>
              <ListItem pl={4}>
                <Text>
                  Give it{' '}
                  <Text display="inline" color="primary">
                    Owner
                  </Text>{' '}
                  role
                </Text>
              </ListItem>
            </OrderedList>
          </ListItem>
        </OrderedList>
      </Stack>
      <Stack spacing={4}>
        <HStack align={'start'}>
          <HelpCount count={2} />
          <HStack>
            <Text fontWeight={600}>
              Ensure your username has the following role assigned to it
            </Text>
          </HStack>
        </HStack>
        <Box pl={8}>
          <CommandBox>
            <Stack>
              <Box>iam.owner</Box>
              <Box>iam.serviceAccountAdmin</Box>
            </Stack>
          </CommandBox>
        </Box>
      </Stack>
    </Stack>
  );
};
